import React from 'react';
import { useExportCodesCsvMutation, useExportToWordMutation } from './mutations';
import { useProject } from '../projects/queries';
import { useAllProjectTranscripts } from '../transcripts/queries';
import { useCodeSidebarCodes } from '../codes/useCodeSidebarCodes';

/**
 * Hook for code exports (used in CodesHeader)
 * Handles CSV and Word exports
 */
export function useCodeExports(projectId) {
  // Get project data
  const { data: projectData, isLoading: projectLoading } = useProject(projectId);

  // Get transcripts data
  const { data: transcripts, isLoading: transcriptsLoading } = useAllProjectTranscripts(projectId);

  // Get codes data (ignoring collapse state for export)
  const { codes: codesData, isLoading: codesLoading } = useCodeSidebarCodes(projectId, true);

  // Create mutations with the data
  const csvMutation = useExportCodesCsvMutation(projectData, codesData);
  const wordMutation = useExportToWordMutation(projectData, codesData, transcripts);

  return {
    exportCsv: () => csvMutation.mutate(),
    exportWord: () => wordMutation.mutate(),
    isExportingCsv: csvMutation.isPending,
    isExportingWord: wordMutation.isPending,
    csvError: csvMutation.error,
    wordError: wordMutation.error,
    isReady: !!projectId && !projectLoading && !transcriptsLoading && !codesLoading && !!projectData && !!codesData
  };
}